<template>
  <div style="width:100%">
    <h2 style="margin-bottom:24px">{{ $t("projectList") }}</h2>

    <h3 class="project-section-title">{{ $t("currentProjects") }}</h3>
    <Collapse accordion simple>
      <Panel
        v-for="project in projects"
        :key="project.id"
        class="project-panel"
      >
        <div
          style="position:absolute;width:100%;height:100%;top:0;display:flex;justify-content:start;align-items:center"
        >
          <p
            style="color:black;z-index:6;font-size:36px;font-weight:700;margin-left:48px"
          >
            {{ project.name }}
          </p>
        </div>
        <div slot="content" style="padding:12px">
          <component :is="project.markdown" class="markdown-body" />
        </div>
      </Panel>
    </Collapse>

    <div class="project-section-divider"></div>

    <h3 class="project-section-title">{{ $t("previousProjects") }}</h3>
    <Collapse accordion simple>
      <Panel
        v-for="project in previousProjects"
        :key="project.id"
        class="project-panel"
      >
        <div
          style="position:absolute;width:100%;height:100%;top:0;display:flex;justify-content:start;align-items:center"
        >
          <p
            style="color:black;z-index:6;font-size:36px;font-weight:700;margin-left:48px"
          >
            {{ project.name }}
          </p>
        </div>
        <div slot="content" style="padding:12px">
          <component :is="project.markdown" class="markdown-body" />
        </div>
      </Panel>
    </Collapse>
  </div>
</template>

<script>
import { mapState } from "vuex";
import "github-markdown-css";

export default {
  computed: {
    ...mapState(["projects", "previousProjects"]),
  },
};
</script>

<style>
.project-panel .ivu-collapse-header {
  height: 200px !important;
}

.project-panel .ivu-collapse-header .ivu-icon {
  display: none;
}

.project-section-title {
  margin-bottom: 16px;
}

.project-section-divider {
  height: 2px;
  background: #dcdee2;
  margin: 32px 0;
}
</style>
